var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"caret-wrapperL",on:{"click":_vm.changeStatus}},[_c('i',{staticClass:"descending",class:{active:_vm.digStatus==1}}),_vm._v(" "),_c('i',{staticClass:"ascending",class:{active:_vm.digStatus==0}})])
}
var staticRenderFns = []

export { render, staticRenderFns }